/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-comment-list[_ngcontent-%COMP%]{border:1px solid #d0d0d0;cursor:pointer}.happ-comment-list[_ngcontent-%COMP%]:hover{background:rgba(200,200,200,.1)}"];
export { styles as styles };
